import React from 'react';
import './index.css';

import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';

import { LandingRoutes } from './routes/LandingRoutes';
import { AuthRoutes } from './routes/AuthRoutes';
import { AlunaRoutes } from './routes/AlunaRoutes';
import { NotificationsProvider } from 'contexts/NotificationsContext';
import { PublicRoutes } from 'routes/PublicRoutes';

export default function App() {
  return (
      <AuthProvider>
        <NotificationsProvider>
          <Router>
            <Routes>
              {PublicRoutes}
              {LandingRoutes}
              {AuthRoutes}
              {AlunaRoutes}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Router>
          </NotificationsProvider>
      </AuthProvider>
  );
}
